<div class="dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <h2>Raw Conversation Records</h2>
      <button mat-raised-button color="accent" (click)="downloadCSV()">
        <mat-icon>file_download</mat-icon> Download CSV
      </button>
    </div>
  </div>

  <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
    <mat-form-field appearance="outline">
      <mat-label>Filter by Phone</mat-label>
      <input matInput [(ngModel)]="filterValues.search" (keyup)="applyDropdownFilter()" placeholder="Search ID...">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Category</mat-label>
      <mat-select [(ngModel)]="filterValues.category" (selectionChange)="applyDropdownFilter()">
        <mat-option value="">All Categories</mat-option>
        <mat-option *ngFor="let cat of categories" [value]="cat">{{cat}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Outcome</mat-label>
      <mat-select [(ngModel)]="filterValues.outcome" (selectionChange)="applyDropdownFilter()">
        <mat-option value="">All Outcomes</mat-option>
        <mat-option *ngFor="let out of outcomes" [value]="out">{{out}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort class="styled-table">
      
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let row"> {{row.conversation_date.value | date:'shortDate'}} </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Conversation ID (Phone) </th>
        <td mat-cell *matCellDef="let row"> <strong>{{row.conversation_id}}</strong> </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
        <td mat-cell *matCellDef="let row"> {{row.conversation_category}} </td>
      </ng-container>

      <ng-container matColumnDef="outcome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Outcome </th>
        <td mat-cell *matCellDef="let row">
          <span [ngClass]="{
            'satisfied-text': row.interaction_outcome === 'Satisfied',
            'unsatisfied-text': row.interaction_outcome === 'Not Satisfied'
          }">{{row.interaction_outcome}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> View </th>
        <td mat-cell *matCellDef="let row">
            <button mat-icon-button 
                    color="primary" 
                    (click)="viewRecordDetails(row)" 
                    matTooltip="View full conversation">
            <mat-icon>visibility</mat-icon>
            </button>
        </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['date', 'phone', 'category', 'outcome', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['date', 'phone', 'category', 'outcome', 'actions'];"></tr>

      <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
    </table>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
  </div>
</div>